export default __webpack_public_path__ + "static/media/ic_duotone_arrow_bottom.7f0cac8b.svg";